import env from './../environments/environment'

const stripePrices = {
  local: {
    one_time: 'price_1TGu9dCB1dfLO0v7dOP00NAM',
    recurring: 'price_1JervOCB1dfLO0v7FpeQ5Idq',
    crm: 'price_1MOYILCB1dfLO0v7aifcgevK',
  },
  beta: {
    one_time: 'price_1TGu9dCB1dfLO0v7dOP00NAM',
    recurring: 'price_1JervOCB1dfLO0v7FpeQ5Idq',
    crm: 'price_1MOYILCB1dfLO0v7aifcgevK',
  },
  production: {
    one_time: 'price_1TGu4cCB1dfLO0v7mt7vzYYQ',
    recurring: 'price_1J8qcjCB1dfLO0v7AqYYcx88',
  },
}

export default stripePrices[env.env]
